export * from './date.type.component';
export * from './checkbox.type.component';
export * from './grid-afmetingen.type.component';
export * from './ibaninput.type.component';
export * from './input.type.component';
export * from './textarea.type.component';
export * from './kendo-multiselect.type.component';
export * from './multicheckbox.type.component';
export * from './radio.type.component';
export * from './repeat.type.component';
export * from './policeregion.type.component';
export * from './repeat.type';
export * from './text.type.component';
